<script setup>
const props = defineProps({
  to: {
    type: String,
    default: undefined,
  },
  href: {
    type: String,
    default: undefined,
  },

  type: {
    type: String,
    default: 'button',
  },

  isStaticByDefault: {
    type: Boolean,
    default: false,
  },
  staticTag: {
    type: String,
    default: 'div',
  },

  target: {
    type: String,
    default: undefined,
  },
  download: {
    type: [Boolean, String],
    default: false,
  },

  activeClass: {
    type: String,
    default: undefined,
  },
  exactActiveClass: {
    type: String,
    default: undefined,
  },
});

const emit = defineEmits(['click']);

const component = computed(() => {
  switch (true) {
    case !!props.to:
      return resolveComponent('c-localized-link');
    case !!props.href:
      return 'a';
    case props.isStaticByDefault:
      return props.staticTag;
    default:
      return 'button';
  }
});

const componentProps = computed(() => {
  const componentProps = {};

  switch (component.value) {
    case resolveComponent('c-localized-link'):
      componentProps.to = props.to;
      if (props.target) componentProps.target = props.target;
      if (props.activeClass) componentProps.activeClass = props.activeClass;
      if (props.exactActiveClass)
        componentProps.exactActiveClass = props.exactActiveClass;
      break;
    case 'a':
      componentProps.href = props.href;
      if (props.target) componentProps.target = props.target;
      if (props.download) {
        if (typeof props.download === 'boolean') {
          componentProps.download = '';
        } else {
          componentProps.download = props.download;
        }
      }
      break;
    case 'button':
      componentProps.type = props.type;
      break;
  }

  return componentProps;
});

function emitClick(event) {
  emit('click', event);
}
</script>

<template>
  <component :is="component" v-bind="componentProps" @click="emitClick">
    <slot />
  </component>
</template>
